module.exports = __webpack_public_path__ + "images/arrow-50e0d937aa07ee324c959dc9ff0e7758.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/arrow.svg
// module id = 226
// module chunks = 0